import { Grid, Box, Title, Text, Button, Image, Stack, rem } from '@mantine/core';
import SuperChargeLogo from '@assets/supercharge-icon.png';
import { Link } from 'react-router-dom';
import { Header } from '@components/header';
import { Footer } from '@components/footer';
import classes from './landing.module.css';

function LandingPage() {
  return (
    <Grid gutter={0} className={classes.grid}>
      <Grid.Col span={4} className={classes.leftBanner}>
        <Box bg="btb-orange" mt="15vh" ml={rem(20)} mr={rem(20)}>
          <Title ta="center" c="white">
            SUPERCHARGE
          </Title>
          <Image src={SuperChargeLogo} />
          <Title ta="center" c="white">
            Your Strategic Playbook
          </Title>
        </Box>
      </Grid.Col>
      <Grid.Col span={8}>
        <Stack align="center" justify="center" className={classes.mainStack}>
          <Header mt={rem(10)} />
          <Title ta="center" size={rem(50)} maw={rem(500)} mt={rem(30)} mb={rem(30)}>
            Generate Actionable OKRs in Seconds
          </Title>
          <Text>
            Already have an account? Log-in{' '}
            <Link to="/get-started" state={{ initialState: 'signIn' }}>
              here
            </Link>
          </Text>

          <Button
            size="xl"
            className={classes.button}
            mt={rem(10)}
            component={Link}
            to="/get-started"
            state={{ initialState: 'signUp' }}
          >
            <Title>CREATE YOURS NOW</Title>
          </Button>
          <Text ta="center" fz="xl" maw={rem(600)} pt={rem(75)} mb={rem(50)}>
            Leveraging the company name and website you provide, our application generates an overview of your
            company. Based on this overview, we then craft tailored Objectives and Key Results (OKRs)
            following the principles outlined in "Beyond the Building."
          </Text>
          <Footer />
        </Stack>
      </Grid.Col>
    </Grid>
  );
}

export { LandingPage };
